/** Montant en CHF arrondi au franc : 12'345 */
export function fmtCHF(n: number): string {
  return Math.round(n).toLocaleString('fr-CH');
}

/** Montant en CHF avec centimes quand ils existent : 5'382.90 */
export function fmtCHF2(n: number): string {
  const arrondi = Math.round(n * 100) / 100;
  return arrondi.toLocaleString('fr-CH', {
    minimumFractionDigits: Number.isInteger(arrondi) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

/** Taux d'occupation : 0.075 -> « 7,5 % » (décimale fr-CH, espace avant % — typographie française) */
export function fmtPct(t: number): string {
  const v = Math.round(t * 1000) / 10;
  return `${v.toLocaleString('fr-CH', { maximumFractionDigits: 1 })} %`;
}

/** '2026-07-01' -> « 07.2026 » ; '2026-07-15' -> « 15.07.2026 » */
export function fmtMoisFr(iso: string): string {
  const [y, m] = iso.split('-');
  return `${m}.${y}`;
}

export function fmtDateFr(iso: string | null): string {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${d}.${m}.${y}`;
}

/** Entier formaté fr-CH : 1'234 */
export function fmtInt(n: number): string {
  return Math.round(n).toLocaleString('fr-CH');
}

/** Heures : 12.5 -> « 12.5 h » (une décimale au plus) */
export function fmtHeures(n: number): string {
  const v = Math.round(n * 10) / 10;
  return `${v.toLocaleString('fr-CH', { maximumFractionDigits: 1 })} h`;
}

/** Taux nul/undefined -> tiret ; sinon pourcentage. */
export function fmtPctOuTiret(t: number | null): string {
  return t == null ? '—' : fmtPct(t);
}

/** Nombre à 2 décimales fr-CH (tiret si null) : 12.21 ; 2.5 -> « 2.5 ». */
export function fmtNb2(n: number | null): string {
  if (n == null) return '—';
  return n.toLocaleString('fr-CH', { maximumFractionDigits: 2 });
}
